import { render, staticRenderFns } from "./SoftwareLicenseText.vue?vue&type=template&id=accf2972&scoped=true&"
import script from "./SoftwareLicenseText.vue?vue&type=script&lang=js&"
export * from "./SoftwareLicenseText.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareLicenseText.vue?vue&type=style&index=0&id=accf2972&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accf2972",
  null
  
)

export default component.exports